/**
 * Sticky checkout bar for cart page
 * Shows a fixed checkout button and total when scrolling past the main checkout area
 * Provides quick access to checkout functionality throughout the cart page
 */

class CartStickyCheckoutBar extends HTMLElement {
  constructor() {
    super();

    // Reference to the cart totals section
    this.cartTotals = document.querySelector('.cart__totals');
    this.freeShippingThreshold = parseInt(this.dataset.freeShippingThreshold || 0);
    this.totalPriceElement = this.querySelector('[data-sticky-total-price]');
    this.freeShippingElement = this.querySelector('[data-sticky-free-shipping]');
    this.checkoutButton = this.querySelector('[data-sticky-checkout-button]');
    this.staticCheckoutButton = document.querySelector('.cart__checkout-button');

    this.debouncedOnScroll = debounce(() => {
      this.toggleStickyBar();
    }, 10);

    window.addEventListener('scroll', this.debouncedOnScroll.bind(this));
  }

  /**
   * Toggles the visibility of the sticky bar based on scroll position.
   */
  toggleStickyBar() {
    const cartStaticButtonRect = this.staticCheckoutButton.getBoundingClientRect();
    if (cartStaticButtonRect.top >= 0 &&
      cartStaticButtonRect.left >= 0 &&
      cartStaticButtonRect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        cartStaticButtonRect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
          this.hideStickyBar();
    } else {
      this.showStickyBar();
    }
  }

  /**
   * Shows the sticky bar.
   */
  showStickyBar() {
    this.classList.add('sticky-checkout-bar--visible');
    this.updateStickyBar();
  }

  /**
   * Hides the sticky bar.
   */
  hideStickyBar() {
    this.classList.remove('sticky-checkout-bar--visible');
  }

  /**
   * Updates the total price and free shipping message in the sticky bar.
   */
  updateStickyBar() {
    const totalPrice = document.querySelector('[data-cart-total-price]');

    // Update total price
    this.totalPriceElement.innerHTML = totalPrice.innerHTML


  }
}

if (!customElements.get('cart-sticky-checkout-bar')) {
  customElements.define('cart-sticky-checkout-bar', CartStickyCheckoutBar);
}